// extracted by mini-css-extract-plugin
module.exports = {"hidden":"notice_hidden__UVphG","textEmphasis":"notice_textEmphasis__p0GvL","editor":"notice_editor__uoykp"};